import React from 'react';
import { Route } from 'react-router';
import _ from 'lodash';
import LiveScreen from 'screens/Live';
import WatchlistScreen from 'screens/Watchlist';
import CollectionScreen from 'screens/Collection';
import BrowseScreen from 'screens/Browse';
import { slugify } from 'helpers/ContentHelper';
import { userAttributeEvents as optimizelyUserAttributeEvents } from 'helpers/OptimizelyHelper';

const onHomeLoad = () => optimizelyUserAttributeEvents().home();
const onBrowseLoad = () => {
  optimizelyUserAttributeEvents().browse();
};
const onLiveLoad = () => {
  optimizelyUserAttributeEvents().live();
};
const noop = () => {};
const REDESIGN_COMPONENT_MAP = {
  'live-news': {
    component: LiveScreen,
    onLoad: onLiveLoad,
  },
  live: {
    component: LiveScreen,
    onLoad: onLiveLoad,
    routeParams: '(/nav)(/schedule)(/channel/:callSign)',
  },
  sports: {
    onLoad: noop,
  },
  audio: {
    onLoad: () => noop,
  },
  personalities: {
    onLoad: () => noop,
  },
  watchlist: {
    component: WatchlistScreen,
    onLoad: () => noop,
  },
  shows: {
    onLoad: () => noop,
    routeParams: '(/:collectionId)',
  },
  collections: {
    onLoad: () => noop,
  },
  browse: {
    component: BrowseScreen,
    onLoad: () => noop,
    routeParams: '(/:browseFilterId)',
  },
  featured: {
    onLoad: noop,
    routeParams: '(/:collectionId)',
  },
  // TODO: add additional data objects from original routes (param, component, onload, etc.)
};
const getNavItems = () => _.get(window.ExternalConfig, 'navigation', []);
const getPathRoot = path => path && (path.split('/').filter(Boolean)[0] || '/');
const getComponentFromRoute = id =>
  _.get(REDESIGN_COMPONENT_MAP, `${_.toLower(id)}.component`, CollectionScreen);
const getRouteParams = id => _.get(REDESIGN_COMPONENT_MAP, `${_.toLower(id)}.routeParams`, '');
const getOnLoadFromRoute = id => {
  if (id === '/') return onHomeLoad;
  return _.get(REDESIGN_COMPONENT_MAP, `${_.toLower(id)}.onLoad`, onBrowseLoad);
};

const navItems = getNavItems() || [];

const REDESIGN_PATH_SCREEN_URL_MAP = navItems.reduce((obj, item) => {
  // TODO: handle links that are not root only
  const { link, screenUrl } = item;
  const rootPath = getPathRoot(link);
  obj[rootPath] = screenUrl; // eslint-disable-line no-param-reassign
  return obj;
}, {});

const defaultRoot = REDESIGN_PATH_SCREEN_URL_MAP['/'];
export const rootScreenUrl = defaultRoot || _.get(navItems, '0.link', '/');

export const getRouteScreenUrl = path => {
  if (!path) return null;
  const pathRoot = getPathRoot(path);
  return REDESIGN_PATH_SCREEN_URL_MAP[pathRoot] || rootScreenUrl;
};
export const getDesignV2Routes = () => {
  const routes = getNavItems().map(item => {
    const { link, screenUrl, label } = item;
    const rootPath = getPathRoot(link);
    const routeParams = getRouteParams(rootPath);
    const key = `route-key-${slugify(label)}-${slugify(link)}`;
    return (
      <Route
        key={key}
        path={`${rootPath}${routeParams}`}
        component={getComponentFromRoute(rootPath)}
        screenUrl={screenUrl}
        onEnter={getOnLoadFromRoute(rootPath)}
      />
    );
  });
  return routes;
};
